import clsx from 'clsx';
import Link from 'next/link';
import ArrowRight from '../../../../svg/Arrows/arrow-right.svg';
import CheerMascot from '../../../../svg/Mascots/cheer-white-arms.svg';
import styles from './Offer50OffBanner.module.css';

const Offer50OffBanner = () => {
  return (
    <Link href={'/choose-your-plan'}>
      <div className={clsx('daymadeTypographyReset', styles.outerContainer)}>
        <div className={styles.innerContainer}>
          <CheerMascot />
          <div
            className={clsx(styles.textContainer, 'daymadeTypographySMedium')}
          >
            Get 50% off your first order{' '}
            <span className={styles.arrow}>
              <ArrowRight />
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Offer50OffBanner;
